import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const WelcomeEmailDrip = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 151 64"
        data-fill-none
      >
        <rect
          width="151"
          height="64"
          rx="4"
          fill="#F6F1EB"
        />
        <path
          d="M60.9792 26.9648V37.0336L53.5483 32.0735L60.9792 26.9648Z"
          fill="#C9DBFF"
        />
        <path
          d="M96.2755 32.0751L88.8447 37.0351V27.3848L96.2755 32.0751Z"
          fill="#C9DBFF"
        />
        <path
          d="M96.2755 32.0742V51.5801C96.2755 52.3191 95.9819 53.0279 95.4593 53.5505C94.9368 54.0731 94.228 54.3667 93.489 54.3667H56.3349C55.5959 54.3667 54.8871 54.0731 54.3645 53.5505C53.8419 53.0279 53.5483 52.3191 53.5483 51.5801V32.0742L60.9792 37.0343L67.9827 41.6971L68.41 41.3627H81.4139L81.8412 41.6971L88.8447 37.0343L96.2755 32.0742Z"
          fill="#C9DBFF"
        />
        <path
          d="M90.8105 11.6946V36.0498L81.9818 41.7904L81.4943 41.4087H68.3289L67.8413 41.7904L59.0127 36.0498V11.6946C59.0127 11.1323 59.236 10.5929 59.6336 10.1953C60.0311 9.79762 60.5703 9.57422 61.1325 9.57422H88.6906C89.2528 9.57422 89.792 9.79762 90.1896 10.1953C90.5871 10.5929 90.8105 11.1323 90.8105 11.6946Z"
          fill="white"
        />
        <path
          d="M85.4656 9.99219H60.9022C60.4011 9.99219 59.9205 10.1907 59.5661 10.544C59.2118 10.8972 59.0127 11.3764 59.0127 11.876V35.7443L59.9272 36.3509L86.2082 10.1467C85.9738 10.0451 85.7211 9.99258 85.4656 9.99219Z"
          fill="white"
        />
        <path
          d="M90.8108 28.8203L96.2755 32.0754V51.5813C96.2755 52.3204 95.9819 53.0291 95.4593 53.5517C94.9368 54.0743 94.228 54.3679 93.489 54.3679H56.3349C55.5959 54.3679 54.8871 54.0743 54.3645 53.5517C53.8419 53.0291 53.5483 52.3204 53.5483 51.5813V32.0754L58.8038 28.8203"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.1211 48.7941L68.4096 41.3633H81.4135L90.702 48.7941"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.2751 32.0742L85.1289 39.505"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53.5483 32.0742L64.6946 39.505"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M90.8105 35.5141V11.8827C90.8105 11.3813 90.5871 10.9004 90.1896 10.5459C89.792 10.1914 89.2528 9.99219 88.6906 9.99219H61.1325C60.5703 9.99219 60.0311 10.1914 59.6336 10.5459C59.236 10.9004 59.0127 11.3813 59.0127 11.8827V35.5141"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.5522 17.2129H70.2677"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M70.2671 22.7852H83.271"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.5522 28.3594H83.2716"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.5522 33.9336H83.2716"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
